import { gql } from "generated-graphql";

/**
 * The two halves of the compliance feed, fetched separately and merged on the
 * client. They stay separate documents because their scopes and freshness
 * differ: container findings are derived at read, while manifest findings are
 * only as current as the last process-manifests run.
 */
export const WASTE_COMPLIANCE_FINDINGS_QUERY = gql(`
  query WasteComplianceFindings(
    $tenantId: ID!
    $containerKinds: [ContainerFindingKind!]
    $manifestKinds: [DiscrepancyKind!]
    $page: Int
    $containerPageSize: Int
    $manifestPageSize: Int
  ) {
    tenant(id: $tenantId) {
      id
      containerComplianceFindings(
        kinds: $containerKinds
        page: $page
        pageSize: $containerPageSize
      ) {
        count
        countsByKind {
          kind
          count
        }
        items {
          id
          kind
          severity
          entity
          entityLabel
          facilityId
          containerId
          areaId
          wasteStreamId
          title
          detail
          deadline
        }
      }
      manifestComplianceFindings(
        kinds: $manifestKinds
        page: $page
        pageSize: $manifestPageSize
      ) {
        count
        countsByKind {
          kind
          count
        }
        items {
          id
          kind
          severity
          status
          field
          ruleKey
          escalation
          facilityId
          facilityName
          epaId
          manifestTrackingNumber
          processedManifestId
          wasteLineUnifiedId
          createdAt
          wasteManifestCorrectionRequest {
            id
            requestDate
          }
        }
      }
    }
  }
`);
